import React from 'react';
import { CTAButton } from '../CTAButton';
import { ImageSlot } from '../ImageSlot';
import { IMAGES, PRICE } from '../../data/landing';
import { useHeroVariant } from '../../hooks/useHeroVariant';
export function HeroSection() {
  const {
    title,
    accent,
    subtitle
  } = useHeroVariant();
  return <header className="bg-ink pb-14 md:py-20" data-id="element-64" data-mp="1x9ak4y10jrlv">
      <div className="mx-auto grid w-full max-w-[1040px] md:grid-cols-2 md:items-center md:gap-12 md:px-6" data-id="element-65" data-mp="1x8hn4oruwggx">
        <ImageSlot name="INOLVIDABLE · El arte del placer con tus manos, con Beatriz Espina" aspect="aspect-square" src={IMAGES.banner} eager data-id="element-66" data-mp="1sbr6o0c53iuz" />
        <div className="px-6 pt-10 text-center md:px-0 md:pt-0 md:text-left" data-id="element-67" data-mp="1ik4mhehtq9g3">
          <p className="text-[13px] font-medium uppercase tracking-[0.2em] text-gold" data-id="element-68" data-mp="1dm33etkeea4m">
            Clase en video · Solo mayores de 18
          </p>
          <h1 className="mt-5 font-serif text-[2.75rem] font-medium leading-[1.04] text-ivory md:text-[4rem]" data-id="element-69" data-mp="14k3m005h1415">
            {title} <em className="italic text-gold" data-id="element-70" data-mp="31nm8bq3kkveu">{accent}</em>
          </h1>
          <p className="mx-auto mt-5 max-w-[480px] text-[17px] leading-relaxed text-ivory/90 md:mx-0 md:text-lg" data-id="element-71" data-mp="31mb8g1d8w7t0">
            {subtitle}
          </p>
          <p className="mt-7 font-serif text-[2.5rem] font-medium leading-none text-gold" data-id="element-72" data-mp="2sor2if4ftnc2">{PRICE}</p>
          <div className="mt-5" data-id="element-73" data-mp="2wpuhz0ikphcr">
            <CTAButton data-id="element-74" data-mp="2wmygx3bfick3" />
          </div>
          <p className="mt-4 text-sm text-ivory/70" data-id="element-75" data-mp="3ke3wdhdgj2tv">Garantía de 7 días · Pago seguro · Acceso inmediato</p>
        </div>
      </div>
    </header>;
}